import React from 'react';
import styles from './HeroSection.module.css';

const HeroSection = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.overlay}></div>  {/* Capa de superposición para dar un toque oscuro al fondo */}
      <div className={styles.content}>
        <h1 className={styles.title}>¡Haz realidad tus sueños con Megaloto!</h1>
        <p className={styles.subtitle}>
          Participa en los sorteos más emocionantes y gana premios increíbles de manera rápida y segura.
        </p>
        <a href="/login" className={styles.cta}>
          ¡Empieza ahora!
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
